export default function queryParams() {
    const query = window.location.search;

    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
            let [key, value] = param.split('=');
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return params;
        }, {});
}



// WEBPACK FOOTER //
// ./src/app/utils/query-params.js